import { render, staticRenderFns } from "./_siteUrlField.vue?vue&type=template&id=20c7c99a"
import script from "./_siteUrlField.vue?vue&type=script&lang=js"
export * from "./_siteUrlField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports